/**
 * Pdf portal
 * Portal to generate PDF and handle authentication.
 *
 * OpenAPI spec version: 1.0.32
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { OrderByEnum } from './orderByEnum';

export interface OrderedGroupPost { 
    kindergartenId: number;
    kindergartenUuid: string;
    testUuid: string;
    groupUuids?: Array<string>;
    includeChildrenWithoutGroups?: boolean;
    dateFrom: string;
    dateTo: string;
    ageFromYears: number;
    ageFromMonths: number;
    ageToYears: number;
    ageToMonths: number;
    orderBy?: OrderByEnum;
}